import {  Typography, Container,Button,Box } from "@mui/material";

const SubmittedMessage = ({ onClose }) => {
    return (
      <Box
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1300, // Ensures it appears above other content
          backgroundColor: "rgba(255, 255, 255, 0.95)", // Light transparent background
          boxShadow: 3,
          borderRadius: 2,
          padding: 4,
          width: "400px",
        }}
      >
        <Container maxWidth="sm"  sx={{ padding: 4, textAlign: "center" }}>
          {/* <Paper elevation={3} sx={{ padding: 4, textAlign: "center" }}> */}
            <Typography variant="h4" color="primary" gutterBottom>
              Application Submitted
            </Typography>
            <Typography variant="body1">
              Your application has already been submitted.
            </Typography>
            <Button onClick={onClose} variant="contained" sx={{ mt: 2 }}>
              OK
            </Button>
          {/* </Paper> */}
        </Container>
      </Box>
    );
  };
  

export default SubmittedMessage;